module.exports = __webpack_public_path__ + "static/img/success6.52c58bfc.png";